module.exports = __webpack_public_path__ + "img/p&s-course3.72840af1.jpg";